




import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component({
  name: 'MAnimate'
})
export default class MAnimate extends Vue {
  // TODO
}
